<div
  class="position-fixed top-0 start-0 w-100 d-flex align-items-center justify-content-center"
  style="min-height: 100vh; z-index: 1001; background-color: rgba(0, 0, 0, 0.6)"
>
  <div class="text-center" style="width: 120px">
    <img
        [src]="brandService.theme.logoUrl"
        [alt]="brandService.theme.name + ' Logo'"
        style="width: 160px; height: 58px; object-fit: contain; filter: brightness(0) invert(1);" 
      />

    <div class="loading-progress">
      <div class="loading-progress-bar"></div>
    </div>
  </div>
</div>
